import { Flex } from "antd";
import { ReactNode } from "react";
import { useTranslate } from "@refinedev/core";
import { ItemControlsConfigProvider } from "../controls/ItemControlsConfigProvider";
import { PanelSection } from "./PanelSection";

/**
 * Contextual section shown at the top of a settings tab when a matching item
 * is selected on the canvas. Hosts the per-item controls that previously lived
 * in the (removed) settings toolbar, keeping the same borderless control look.
 */
export const SelectedItemSection = ({
  title,
  children,
}: {
  title?: ReactNode;
  children: ReactNode;
}) => {
  const t = useTranslate();

  return (
    <PanelSection
      title={title ?? t("components.templates.settings.selectedItem")}
    >
      <ItemControlsConfigProvider>
        <Flex align="center" gap={5} wrap="wrap">
          {children}
        </Flex>
      </ItemControlsConfigProvider>
    </PanelSection>
  );
};
